




























































































































































































































import { Component, Vue, Prop, Emit } from "vue-property-decorator";
// Se importa la interfaz completa de Factura
import {
  Factura,
  FacturaItem,
  RegistroHistorialFactura,
} from "@/typings/store/plugins/easyFirestore/facturas";
import { formatearNumero } from "@/helpers/facturacion";
import { NotaCreditoFactura, notasDeFactura } from "@/helpers/notasCredito";
import { PagoFactura, saldoPorCobrar } from "@/helpers/pagosFacturas";

@Component
export default class InfoFactura extends Vue {
  @Prop({ type: Object, required: true }) readonly factura!: Factura;
  @Prop({ type: Boolean, default: false }) readonly showTitulo!: boolean;
  @Prop({ default: () => [] }) readonly notasCredito!: NotaCreditoFactura[];

  get notas(): NotaCreditoFactura[] {
    return notasDeFactura(this.notasCredito, this.factura?.id);
  }

  @Prop({ default: () => [] }) readonly pagos!: PagoFactura[];

  /** Solo las facturas emitidas o pagadas se cobran. */
  get cobrable(): boolean {
    return ["Emitida", "Pagada"].includes(this.factura?.estado);
  }

  /** Pagos de la factura, vigentes y anulados, del más reciente al más antiguo. */
  get pagosFactura(): PagoFactura[] {
    return this.pagos.filter((p) => p.idFactura === this.factura?.id).sort((a, b) => b.fecha.localeCompare(a.fecha));
  }

  get saldo(): number {
    return saldoPorCobrar(this.factura, this.notasCredito, this.pagos);
  }

  // Se crean computed properties para acceder de forma segura a los datos
  get folio(): string | number {
    return this.factura?.folio || "Sin folio";
  }

  get estado(): string {
    return this.factura?.estado || "N/D";
  }

  get periodoFacturado(): string {
    return this.factura?.periodoFacturado || "N/D";
  }

  get cliente(): { nombre: string; rut: string; direccion: string; correo: string } {
    return (
      this.factura?.clienteSnapshot || {
        nombre: "",
        rut: "",
        direccion: "",
        correo: "",
      }
    );
  }

  get fechaEmision(): string {
    return this.factura?.fechaEmision || "";
  }

  get fechaVencimiento(): string {
    return this.factura?.fechaVencimiento || "";
  }

  get montoNeto(): number {
    return this.factura?.montoNeto || 0;
  }

  get montoIva(): number {
    return this.factura?.montoIva || 0;
  }

  get montoTotal(): number {
    return this.factura?.montoTotal || 0;
  }

  get items(): FacturaItem[] {
    return this.factura?.items || [];
  }

  get historial(): RegistroHistorialFactura[] {
    return [...(this.factura?.historial || [])].reverse();
  }

  get motivoAnulacion(): string {
    return this.factura?.motivoAnulacion || "";
  }

  formatearUf(valor: number): string {
    return `${formatearNumero(valor, 4)} UF`;
  }

  formatDateTime(iso: string): string {
    return iso ? new Date(iso).toLocaleString("es-CL") : "";
  }

  // --- MÉTODOS DE FORMATO ---
  formatCurrency(value: number): string {
    if (isNaN(value)) return "$ 0";
    return new Intl.NumberFormat("es-CL", {
      style: "currency",
      currency: "CLP",
    }).format(value);
  }

  formatDate(dateString: string): string {
    if (!dateString) return "N/D";
    const options: Intl.DateTimeFormatOptions = {
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return new Date(dateString).toLocaleDateString("es-CL", options);
  }

  getColorPorEstado(estado: string): string {
    switch (estado) {
      case "Aprobada":
        return "teal";
      case "Emitida":
        return "blue";
      case "Pagada":
        return "green";
      case "Anulada":
        return "red";
      case "Borrador":
      default:
        return "grey";
    }
  }

  @Emit("cerrar")
  onCerrar(): void {
    return;
  }
}
